var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doctor4"},[_c('h3',[_vm._v("王安安 "),_c('el-tag',{attrs:{"type":"success"}},[_vm._v("男")]),_vm._v(" "),_c('el-tag',[_vm._v("23岁")])],1),_vm._v(" "),_c('el-alert',{attrs:{"title":"看诊完成","type":"success","description":"病人情况很好，很快能痊愈。","show-icon":""}}),_vm._v(" "),_c('h4',[_vm._v("其他病人")]),_vm._v(" "),_c('doctor5'),_vm._v(" "),_c('doctor5'),_vm._v(" "),_c('doctor5')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-081a56cc","hasScoped":true,"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor4.vue
// module id = 225
// module chunks = 1